interface IProps {
  bname: "All" | string;
  setSelectedFilter: React.Dispatch<React.SetStateAction<"All" | string>>;
  selectedFilter: "All" | string;
}

const CustomButton = ({ bname, setSelectedFilter, selectedFilter }: IProps) => {
  const isActive = bname === selectedFilter;
  return (
    <div
      onClick={() => setSelectedFilter(bname)}
      className={`
        border cursor-pointer rounded-full px-2 py-1 font-normal text-sm
        hover:bg-border-lilly_pink hover:text-[#f75a5a]
        ${
          isActive
            ? "border-border-lilly_red text-body-text-lilly_red"
            : "border-border-stone text-[#505050] hover:border-[#d31710]"
        }
      `}
    >
      {bname}
    </div>
  );
};

export default CustomButton;
